import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { AvForm } from 'availity-reactstrap-validation'
import { FORM_VESSEL_OP } from '../../actions/constant'
import { portFetchAll } from '../../actions/portAction'
import { latestSchedule } from '../../actions/scheduleAction'
import { operatorFetchAll } from '../../actions/operatorAction'
import { msttrayekFetchAll } from '../../actions/msttrayekAction'
import { routeFetchAll } from '../../actions/routeAction'

import { Card, CardBody, CardHeader, Row, Col, Table, Pagination, PaginationItem, PaginationLink, Button } from 'reactstrap'

let userId = localStorage.getItem('tolaut@userId') || null
let form = localStorage.getItem('tolaut@form') || null

class LatestJadwalKapal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      perPage: 10,
      curPage: 1,
      start: 0,
      operator_id: '',
      operator_label: '',
      trayek: '',
      trayek_label: '',
      port_origin_id: '',
      port_origin_label: '',
      port_destination_id: '',
      port_destination_label: ''
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.selectOperator = this.selectOperator.bind(this)
    this.selectTrayek = this.selectTrayek.bind(this)
    this.selectOrigin = this.selectOrigin.bind(this)
    this.selectDestination = this.selectDestination.bind(this)
  }

  componentDidMount() {
    const data = {
      length: 10
    }

    if (form === FORM_VESSEL_OP) {
      data.operator_id = userId
    }

    this.props.latestSchedule(data)
    this.props.operatorFetchAll()
    this.props.msttrayekFetchAll()
    this.props.portFetchAll()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        trayek: this.state.trayek,
        port_origin_id: this.state.port_origin_id,
        port_destination_id: this.state.port_destination_id
      }

      if (form === FORM_VESSEL_OP) {
        data.operator_id = userId
      } else {
        data.operator_id = this.state.operator_id
      }

      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 10) - 10
        data.start = offset
      }

      // this.props.scheduleFetchWill(data)
      this.props.latestSchedule(data)
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  selectOperator(option) {
    this.setState({
      operator_id: option ? option.value : '',
      operator_label: option ? option.label : ''
    })
  }

  selectTrayek(option) {
    this.setState({
      trayek: option ? option.value : '',
      trayek_label: option ? option.label : ''
    })
  }

  selectOrigin(option) {
    this.setState({
      port_origin_id: option ? option.value : '',
      port_origin_label: option ? option.label : ''
    })
  }

  selectDestination(option) {
    this.setState({
      port_destination_id: option ? option.value : '',
      port_destination_label: option ? option.label : ''
    })
  }

  handleFilter(event, values) {
    values.length = this.state.perPage
    values.trayek = this.state.trayek
    values.port_origin_id = this.state.port_origin_id
    values.port_destination_id = this.state.port_destination_id

    if (form === FORM_VESSEL_OP) {
      values.operator_id = userId
    } else {
      values.operator_id = this.state.operator_id
    }

    // this.props.scheduleFetchWill(values)
    this.props.latestSchedule(values)
  }

  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);
    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }
    return rupiah
  }

  renderSchedule() {
    if (this.props.isScheduleWillSuccess) {
      const defaultValues = {
        operator_id: this.state.operator_id,
        operator_label: this.state.operator_label ? this.state.operator_label : '-- Operator --',
        trayek: this.state.trayek,
        trayek_label: this.state.trayek_label ? this.state.trayek_label : '-- Trayek --',
        port_origin_id: this.state.port_origin_id,
        port_origin_label: this.state.port_origin_label ? this.state.port_origin_label : '-- Origin --',
        port_destination_id: this.state.port_destination_id,
        port_destination_label: this.state.port_destination_label ? this.state.port_destination_label : '-- Destination --'
      }

      const prevPage = parseInt(this.props.schedules.currentPage) - 1
      const nextPage = parseInt(this.props.schedules.currentPage) + 1

      let curPage = this.props.schedules.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.schedules.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      const { operator_id } = this.state.operator_id
      const { trayek } = this.state.trayek
      const { port_origin_id } = this.state.port_origin_id
      const { port_destination_id } = this.state.port_destination_id

      return (
        <div>
          <Row>
            <Col xs="12" sm="12" md="12" lg="12">
              <Card>
                <CardHeader className="text-center">
                  <h5>Jadwal Kapal</h5>
                </CardHeader>
                <CardBody className="p-0">

                  <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                    <Row className="p-4">
                      {form !== FORM_VESSEL_OP &&
                        this.props.isOperatorSuccess &&
                        <Col md="3">
                          <Select
                            name="operator_id"
                            value={operator_id}
                            defaultValue={defaultValues.operator_id ? { label: defaultValues.operator_label, value: defaultValues.operator_id } : []}
                            onChange={this.selectOperator}
                            options={this.props.operators.data}
                            isClearable={true}
                            placeholder="-- Operator --"
                          />
                        </Col>
                      }
                      {form !== FORM_VESSEL_OP &&
                        this.props.isTrayekSuccess &&
                        <Col md="2">
                          <Select
                            name="trayek"
                            value={trayek}
                            defaultValue={defaultValues.trayek ? { label: defaultValues.trayek_label, value: defaultValues.trayek } : []}
                            onChange={this.selectTrayek}
                            options={this.props.msttrayeks.data.map((item) => {
                              item.label = item.kode;
                              item.value = item.id;
                              return item
                            }, [])}
                            isClearable={true}
                            placeholder="-- Trayek --"
                          />
                        </Col>

                      }
                      {this.props.isPortSuccess &&
                        <Col md="3">
                          <Select
                            name="port_origin_id"
                            value={port_origin_id}
                            defaultValue={defaultValues.port_origin_id ? { label: defaultValues.port_origin_label, value: defaultValues.port_origin_id } : []}
                            onChange={this.selectOrigin}
                            options={this.props.ports.data}
                            isClearable={true}
                            placeholder="-- Origin --"
                          />
                        </Col>
                      }
                      {this.props.isPortSuccess &&
                        <Col md="3">
                          <Select
                            name="port_destination_id"
                            value={port_destination_id}
                            defaultValue={defaultValues.port_destination_id ? { label: defaultValues.port_destination_label, value: defaultValues.port_destination_id } : []}
                            onChange={this.selectDestination}
                            options={this.props.ports.data}
                            isClearable={true}
                            placeholder="-- Destination --"
                          />
                        </Col>
                      }
                      <Col md="1">
                        <Button type="submit" color="primary">
                          <i className="fa fa-search"></i>
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>

                  <Table responsive striped size="sm">
                    <thead>
                      <tr>
                        <th className="text-center">Operator Kapal</th>
                        <th className="text-center">Trayek</th>
                        <th className="text-center">Origin</th>
                        <th className="text-center">Destination</th>
                        <th className="text-center">Closing Time BUMN</th>
                        <th className="text-center">Closing Time Swasta</th>
                        <th className="text-center">Tarif</th>
                        <th className="text-center">Sisa Kuota</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.schedules.data.map((item, index) => (
                        <tr key={item.id}>
                          <td className="text-center">
                            {item.operator_kapal_name}
                          </td>
                          <td className="text-center">
                            {item.kode_trayek} Voyage {item.voyage}
                          </td>
                          <td className="text-center">
                            <div className="mb-1">{item.pel_asal}</div>
                            {item.tanggal_berangkat !== null &&
                              moment(item.tanggal_berangkat).format('DD MMM YYYY h:mm')
                            }
                          </td>
                          <td className="text-center">
                            <div className="mb-1">{item.pel_sampai}</div>
                            {item.tanggal_tiba !== null &&
                              moment(item.tanggal_tiba).format('DD MMM YYYY h:mm')
                            }
                          </td>
                          <td className="text-center">
                            {item.tutup_jadwal_shipper_bumn !== null &&
                              moment(item.tutup_jadwal_shipper_bumn).format('DD MMM YYYY h:mm')
                            }
                          </td>
                          <td className="text-center">
                            {item.tutup_jadwal_shipper_swasta !== null &&
                              moment(item.tutup_jadwal_shipper_swasta).format('DD MMM YYYY h:mm')
                            }
                          </td>
                          <td className="text-center">
                            {this.props.schedules.data[index].containers.map((value, idx) => (
                              <div key={idx}>
                                <div className="mb-1">{value.type_container_name}:</div>
                                {
                                  (value.price === null) ?
                                    <>
                                      <span>
                                        <strong>- Rp.{this.changeRupiah(value.lcl_25||0)} {`(25%)`} <br /></strong>
                                        <strong>- Rp.{this.changeRupiah(value.lcl_50||0)} {`(50%)`} <br /></strong>
                                        <strong>- Rp.{this.changeRupiah(value.lcl_75||0)} {`(75%)`} <br /></strong>
                                      </span>
                                    </>
                                    :
                                    <>Rp. {this.changeRupiah(value.price||0)} </>

                                }
                                <hr className="mt-2 mb-2" />
                              </div>
                            ))}
                          </td>
                          <td className="text-center">
                            {this.props.schedules.data[index].containers.map((value, idx) => (
                              <div key={idx}>
                                <div className="mb-1">{value.type_container_name}:</div>
                                {value.sisa_quota} dari {value.alokasi_quota}
                                <hr className="mt-2 mb-2" />
                              </div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Pagination className="mt-2">
            {this.props.schedules.hasPrev ?
              <PaginationItem>
                <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                  First Page
                </PaginationLink>
              </PaginationItem>
              : null
            }

            {this.props.schedules.hasPrev ?
              <PaginationItem>
                <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                  Prev
                </PaginationLink>
              </PaginationItem>
              : null
            }

            {pages.map((item, index) => {
              let actived = false
              if (curPage === undefined) {
                curPage = 1
              }

              if (item == curPage) {
                actived = true
              }

              if (item >= minPage && item <= maxPage) {
                return <PaginationItem active={actived} key={index}>
                  <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                    {item}
                  </PaginationLink>
                </PaginationItem>
              }
            })}

            {this.props.schedules.hasNext ?
              <PaginationItem>
                <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                  Next
                </PaginationLink>
              </PaginationItem>
              : null
            }

            {this.props.schedules.hasNext ?
              <PaginationItem>
                <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                  Last Page
                </PaginationLink>
              </PaginationItem>
              : null
            }
          </Pagination>

          {this.props.schedules.pageTotal > 0 &&
            <p>Page: {this.props.schedules.currentPage} of {this.props.schedules.pageTotal}</p>
          }
        </div>
      )
    }
  }

  render() {
    if (this.props.isScheduleWillLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.hasScheduleWillError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderSchedule()}
      </div>
    )
  }
}

LatestJadwalKapal.propTypes = {
  isScheduleWillSuccess: PropTypes.bool.isRequired,
  hasScheduleWillError: PropTypes.bool.isRequired,
  isScheduleWillLoading: PropTypes.bool.isRequired,

  isOperatorSuccess: PropTypes.bool.isRequired,
  hasOperatorError: PropTypes.bool.isRequired,
  isOperatorLoading: PropTypes.bool.isRequired,

  isTrayekSuccess: PropTypes.bool.isRequired,
  hasTrayekError: PropTypes.bool.isRequired,
  isTrayekLoading: PropTypes.bool.isRequired,

  isPortSuccess: PropTypes.bool.isRequired,
  hasPortError: PropTypes.bool.isRequired,
  isPortLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    schedules: state.schedules.schedules,
    isScheduleWillSuccess: state.schedules.scheduleGetSuccess,
    hasScheduleWillError: state.schedules.scheduleGetError,
    isScheduleWillLoading: state.schedules.scheduleGetLoading,

    operators: state.operators.operators,
    isOperatorSuccess: state.operators.operatorGetSuccess,
    hasOperatorError: state.operators.operatorGetError,
    isOperatorLoading: state.operators.operatorGetLoading,

    msttrayeks: state.routes.routes,
    isTrayekSuccess: state.routes.routeGetSuccess,
    hasTrayekError: state.routes.routeGetError,
    isTrayekLoading: state.routes.routeGetLoading,
    // msttrayeks: state.msttrayeks.msttrayeks,
    // isTrayekSuccess: state.msttrayeks.msttrayekGetSuccess,
    // hasTrayekError: state.msttrayeks.msttrayekGetError,
    // isTrayekLoading: state.msttrayeks.msttrayekGetLoading,

    ports: state.ports.ports,
    isPortSuccess: state.ports.portGetSuccess,
    hasPortError: state.ports.portGetError,
    isPortLoading: state.ports.portGetLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    latestSchedule: (data) => dispatch(latestSchedule(data)),
    operatorFetchAll: () => dispatch(operatorFetchAll()),
    msttrayekFetchAll: () => dispatch(routeFetchAll()),
    portFetchAll: () => dispatch(portFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LatestJadwalKapal)
